import DeleteReview from './delete_review'
import { connect } from 'react-redux'
import { deleteRemotely } from 'redux/modules/campaign'
import { hubPageUrl } from 'lib/campaign_url'
import { getCampaignSelector } from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    operatingRemotely: campaign.operatingRemotely,
    moneyBoxAmount: campaign.money_box_amount,
    error: campaign.err,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onDelete() {
      return dispatch(deleteRemotely(campaignId)).then(() => {
        location.href = hubPageUrl()
      })
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(preventNavigation(DeleteReview, props => props.operatingRemotely))
